import { AVSDK, SessionStateEnum } from "./common";
import Service from "@/services";
import ImService from "@/server/ImService";
import { isFocusEnv } from "@/utils";
import {
  getCurrentMeetingInfo,
  getStatus,
  setCurrentMeetingInfo,
  getPlatform,
  joinMeeting,
  handleMeetingSendMessage
} from "./utils";
import dayjs from "dayjs";
import { createMeeting as requestCreateMeeting } from "@/api/meeting";
import { uniqBy } from "lodash";

/**
 * 创建会议并邀请用户，如已经通过此方法在会议中，直接发送邀请
 * @param param0
 * @param service
 */
export async function createMeetingWithUsers(
  {
    to = [],
    avsdk = AVSDK.JBRTC,
    appKey,
    password = "",
    topic
  }: {
    to?: { openUserId: string; openTeamId: string; name: string }[];
    avsdk?: AVSDK;
    password?: string;
    appKey: string;
    topic: string;
  },
  service: Service
) {
  let users: any = [];
  if (to.length) {
    // 开放平台用户信息换取
    const res = await service.appStoreService.batchExchangeUser({
      appKey,
      openUserTeamIds: to
    });
    users = res.userTeamIds;
  }

  const currentUser = await ImService.getInstance().getCurrentEmployee();
  if (!currentUser || !currentUser.userId) {
    return Promise.reject(new Error("获取用户信息失败"));
  }
  let meetingInfo;
  if (isFocusEnv()) {
    const meetingStatus = await getStatus(avsdk);
    if (meetingStatus) {
      const currentMeetingInfo = getCurrentMeetingInfo(avsdk);
      if (currentMeetingInfo) {
        meetingInfo = currentMeetingInfo;
      } else {
        return Promise.reject(new Error("已经在会议中"));
      }
    }
  }

  if (!meetingInfo) {
    const [meetingInfoRes, err] = await requestCreateMeeting({
      startTime: (dayjs().valueOf() + 5000).toString(),
      duration: 2,
      topic: topic,
      password,
      platform: getPlatform(avsdk),
      participantIds: uniqBy(
        [
          {
            realName: currentUser.name || "",
            teamId: currentUser.teamId || "",
            userId: currentUser.userId || "",
            appId: currentUser.app || "",
            headImg: currentUser.avatar || ""
          }
        ].concat(
          users.map((user: any, index: number) => ({
            realName: to[index].name || "",
            teamId: user.teamId || "",
            userId: user.userId || "",
            appId: currentUser.app || "",
            headImg: ""
          }))
        ),
        "userId"
      )
    });
    if (err || !meetingInfoRes) {
      return Promise.reject(new Error(err || ""));
    }
    setCurrentMeetingInfo(avsdk, meetingInfoRes);
    meetingInfo = meetingInfoRes;
    await joinMeeting(avsdk, {
      meetingNumber: meetingInfo.meetingId.toString(),
      meetingPassword: password,
      isvideooff: true,
      isaudiooff: true
    });
  }

  await handleMeetingSendMessage({
    avsdk,
    meetingInfo: {
      password: "",
      meetingTopic: topic,
      meetingNumber: meetingInfo.meetingId.toString()
    },
    sessionState: SessionStateEnum.Call,
    toUsers: users.map((u: any, i: number) => ({
      userId: u.userId,
      teamId: u.teamId,
      pin: u.userId,
      app: currentUser.app || "",
      avatar: "",
      name: to[i].name || ""
    }))
  });
  return meetingInfo;
}
